import { AHIcon, AHText, Box, TouchableBox, useLayoutContext } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { Image } from "expo-image";
import { ProductExpireBatchProductPreview_StoreProduct$key } from "./__generated__/ProductExpireBatchProductPreview_StoreProduct.graphql";

export function ProductExpireBatchProductPreview(props: {
  product: ProductExpireBatchProductPreview_StoreProduct$key;
  onPress: () => void;
}) {
  const product = useFragment(
    graphql`
      fragment ProductExpireBatchProductPreview_StoreProduct on StoreProduct {
        id
        name
        partNumber
        imageUrl
      }
    `,
    props.product
  );
  const layout = useLayoutContext();
  return (
    <TouchableBox
      style={{ flexDirection: "row", alignItems: "center" }}
      spaceVertical="medium"
      onPress={props.onPress}
    >
      {product.imageUrl ? (
        <Image
          source={{ uri: product.imageUrl }}
          style={{
            width: layout.circle.medium,
            height: layout.circle.medium,
            marginLeft: layout.space.medium,
          }}
        />
      ) : null}
      <Box style={{ flex: 1 }} spaceLeft="medium">
        <AHText type="subtitle" spaceBottom="xsmall">
          {product.partNumber}
        </AHText>
        <AHText type="subtitle">{product.name}</AHText>
      </Box>
      <AHIcon
        type="arrow-up-right"
        color="washedText"
        spaceHorizontal="medium"
      />
    </TouchableBox>
  );
}
